import { connect, useDispatch } from 'react-redux';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import * as React from 'react';
import { bindActionCreators, Dispatch, AnyAction } from 'redux';

import { displayTime } from '../utils/utils';
import { ActionCreators, EntityBalanceResponse, EntityBalanceType } from '../entityBalance/entityBalance';
import { TypedBalance } from './typedBalance';
import { EntitlementCategoriesConfig, PredefinedCurrency } from '../app/appConfig';
import AppState from '../app/store/state';

interface Props {
    lastBalance: EntityBalanceResponse;
    loadLastEntityBalance: (entityId: string, entityType: EntityBalanceType) => void;
    currency: PredefinedCurrency;
    categories: EntitlementCategoriesConfig;
}

class BeneficiariesTotals extends React.Component<Props> {
    constructor(props: Props) {
        super(props);
    }

    location = useLocation();

    componentDidMount(): void {
        const beneficiaryId = this.location?.state?.beneficiaryId;
        if (beneficiaryId) {
            this.props.loadLastEntityBalance(beneficiaryId, EntityBalanceType.Beneficiary);
        }
    }

    sectionHeader(title: string) {
        return <h6>{title}</h6>;
    }

    calculationData() {
        const { lastBalance } = this.props;
        if (lastBalance && lastBalance.lastTransactionAt) {
            return <small>Above totals were calculated {displayTime(lastBalance.lastTransactionAt)} </small>;
        } else {
            return null;
        }
    }

    renderTotalsOfGivenCategory(category: string) {
        const beneficiaryId = this.location?.state?.beneficiaryId;
        if (!beneficiaryId) return null;

        return (
            <div key={category}>
                {this.sectionHeader(`Beneficiary totals of type ${category}`)}
                <div className="beneficiary-totals-component">
                    <div>
                        <TypedBalance
                            beneficiaryId={beneficiaryId}
                            currency={this.props.currency}
                            desiredCategory={category}
                            entityBalance={this.props.lastBalance}
                        />
                    </div>
                    {this.calculationData()}
                </div>
            </div>
        );
    }

    render() {
        const { categories } = this.props;
        return (
            <div>
                {categories && categories.categories
                    ? categories.categories.map((category) => this.renderTotalsOfGivenCategory(category))
                    : null}
                <small>
                    Beneficiary totals are calculated automatically every hour, if beneficiary has made any transactions
                </small>
            </div>
        );
    }
}

function mapDispatchToProps(dispatch: Dispatch<AnyAction>) {
    return {
        loadLastEntityBalance: bindActionCreators(ActionCreators.loadLastEntityBalance, dispatch),
    };
}

function mapStateToProps(state: AppState) {
    return {
        lastBalance: state.entityBalance.lastEntityBalance,
        categories: state.appConfig.entitlementsConfig,
        currency: state.appConfig.entitlementCurrencyConfig,
    };
}

const withHooks = (Component: any) => {
    // eslint-disable-next-line react/display-name
    return (props: any) => {
        const location = useLocation();
        const params = useParams();
        const navigate = useNavigate();
        const dispatch = useDispatch();

        return <Component {...props} dispatch={dispatch} location={location} navigate={navigate} params={params} />;
    };
};

export default connect(mapStateToProps, mapDispatchToProps, null)(withHooks(BeneficiariesTotals));
